import PmcBridge from 'shared/services/pmc-bridge'

export default class MenuUser {
	private menuUser: HTMLElement | null
	private pmcBridge: PmcBridge
	private isUserConnected: Awaited<ReturnType<typeof PmcBridge.prototype.isConnected>>
	private menuUserTrigger: HTMLElement | null | undefined
	private avatarUrl: Awaited<ReturnType<typeof PmcBridge.prototype.getAvatar>>

	constructor() {
		this.menuUser = document.querySelector('.menuUser')
		this.pmcBridge = new PmcBridge()
		this.isUserConnected = false
		this.menuUserTrigger = this.menuUser?.querySelector('.menuUser-trigger.user')
		this.avatarUrl = ''

		this.setMenuUserConnected = this.setMenuUserConnected.bind(this)
		this.showMenuTrigger = this.showMenuTrigger.bind(this)
		this.showUserAvatar = this.showUserAvatar.bind(this)
		this.toggleMenu = this.toggleMenu.bind(this)
	}

	async init() {
		const [isUserConnected, avatarUrl] = await Promise.all([
			this.pmcBridge.isConnected(),
			this.pmcBridge.getAvatar()
		])

		this.isUserConnected = isUserConnected
		this.avatarUrl = avatarUrl

		this.showMenuTrigger()

		if (this.isUserConnected) {
			this.setMenuUserConnected()
		}

		this.addEvents()
	}

	/**
	 * Add events
	 * @returns {void}
	 */
	addEvents(): void {
		this.menuUserTrigger?.addEventListener('click', this.toggleMenu)
	}

	/**
	 * Update the menu button label
	 */
	setMenuUserConnected() {
		this.menuUser?.classList.add('isConnected')
		this.updateAccountLinks()

		if (this.avatarUrl) {
			this.showUserAvatar(this.avatarUrl)
		}
	}

	showMenuTrigger() {
		this.menuUser?.classList.add('authStatusLoaded')
	}

	toggleMenu() {
		this.menuUser?.classList.toggle('opened')
	}

	async updateAccountLinks() {
		const dropdownLinks = this.menuUser?.querySelectorAll('[data-pmc-link]') ?? []
		const domain = await this.pmcBridge.getPmcDomain()
		const subscription = await this.pmcBridge.getAllSubscriptions()

		if (subscription.includes('paid-web-content')) {
			this.menuUser?.classList.add('isUserSubscribedWeb')
		}
		if (subscription.includes('paid-web-magazine')) {
			this.menuUser?.classList.add('isUserSubscribedMagazine')
		}

		for (const dropdownLink of dropdownLinks) {
			const url = dropdownLink.getAttribute('data-pmc-link')
			dropdownLink.setAttribute('href', `${domain}/${url}`)
		}
	}

	showUserAvatar(avatarUrl: string) {
		const triggerLabel = this.menuUserTrigger?.querySelector('.menuUser-triggerLabel')

		if (triggerLabel && avatarUrl) {
			// Créer un nouvel élément image
			const avatarImg = document.createElement('img')
			avatarImg.setAttribute('src', avatarUrl)
			avatarImg.setAttribute('class', 'menuUser-triggerAvatar')
			avatarImg.setAttribute('aria-hidden', 'true')
			avatarImg.setAttribute('alt', 'avatar')

			// Insérer l'image juste avant l'élément avec la classe "menuUser-triggerLabel"
			triggerLabel.parentNode?.insertBefore(avatarImg, triggerLabel)

			this.menuUser?.classList.add('hasAvatar')
		}
	}
}
